import { useMemo } from 'react';

import { InventoryDetails } from 'parts/components/PartDetails/Inventory/InventoryDetails';
import { ISalesOrderDetail } from 'parts/types';

import { columnDef } from './columns';

interface IProps {
  records: ISalesOrderDetail[];
  tableId: string;
  title: string;
  onClose: () => void;
  isOpen: boolean;
}

export const SalesOrders = ({ records, tableId, title, onClose, isOpen }: IProps) => {
  const columnDefs = useMemo(() => columnDef(), []);

  return (
    <InventoryDetails
      records={records}
      columnDefs={columnDefs}
      tableId={tableId}
      entityType="SalesOrder"
      title={title}
      onClose={onClose}
      isOpen={isOpen}
    />
  );
};
